// ── BOUTON « TELECHARGER » — COMPOSANT PARTAGE, UNE SEULE IMPLEMENTATION ────
// Emplacement propose : frontend/src/components/shared/BoutonTelechargerDocument.jsx
//
// ⚠️ UN SEUL COMPOSANT POUR LES 8 ECRANS. Libelle, icone, etats et gestion
//    d'erreur vivent ICI et nulle part ailleurs. Un utilisateur qui a compris
//    le bouton sur un ecran l'a compris sur les huit.
//
// ⚠️ CE COMPOSANT NE COMPOSE AUCUN NOM DE FICHIER. Il passe l'URL a
//    `telechargerDocument`, qui LIT le nom dans l'en-tete du serveur. Il n'a
//    pas de prop `nom`, pas de repli local, pas de valeur par defaut : lui en
//    donner une recreerait le second endroit de verite qu'on cherche a eviter.
//
// ⚠️ IL NE REMPLACE PAS LE BOUTON D'APERCU. L'apercu garde sa position, son
//    comportement et son onglet. Ce bouton s'ajoute, il ne substitue rien.
import React, { useState } from 'react';
import { telechargerDocument } from 'services/documents';

// ⚠️ `format` est le LIBELLE DU BOUTON, pas le nom du fichier. Les deux ne se
//    confondent pas : le nom vient toujours de l'en-tete du serveur. Cette prop
//    existe parce que DEUX BOUTONS NE PORTENT JAMAIS LE MEME LIBELLE — l'ecran
//    Contrats de travail sert un PDF *et* un Word, et le lot du 31/08 avait
//    efface cette distinction en remplacant « DOCX » par un « Telecharger »
//    identique a celui du PDF. Le format se lit sur le bouton.
export default function BoutonTelechargerDocument({ url, format = 'PDF', disabled = false }) {
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  const clic = async () => {
    setErreur(null);
    setEnCours(true);
    try {
      await telechargerDocument(url);
    } catch (e) {
      // On NOMME l'echec plutot que de laisser un bouton qui ne fait rien :
      // un clic sans effet se lit comme une panne du poste, pas du serveur.
      setErreur(e?.message || 'Telechargement impossible');
    } finally {
      setEnCours(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="gss-btn-sm"
        onClick={clic}
        disabled={disabled || enCours}
        title={erreur || `Telecharger le document (${format}) sous son nom complet`}
      >
        {enCours ? '…' : `↓ ${format}`}
      </button>
      {erreur && (
        <span className="gss-erreur-inline" role="alert" style={{ marginLeft: 6, fontSize: 11 }}>
          {erreur}
        </span>
      )}
    </>
  );
}
